import { createContext, useContext, useEffect, type ReactNode } from "react";

export interface BrandTokens {
  name: string;
  tagline: string;
  supportEmail: string;
  colors: Record<string, string>;
  fonts: { sans: string; mono: string };
  copy: Record<string, string>;
}

const BrandContext = createContext<BrandTokens | null>(null);

export function ThemeProvider({
  brand,
  children,
}: {
  brand: BrandTokens;
  children: ReactNode;
}) {
  useEffect(() => {
    const root = document.documentElement;
    for (const [key, value] of Object.entries(brand.colors)) {
      root.style.setProperty(`--${key}`, value);
    }
    root.style.setProperty("--font-sans", brand.fonts.sans);
    root.style.setProperty("--font-mono", brand.fonts.mono);
    document.title = brand.name;
  }, [brand]);

  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand(): BrandTokens {
  const ctx = useContext(BrandContext);
  if (!ctx) {
    throw new Error("useBrand must be used inside <ThemeProvider>");
  }
  return ctx;
}
